import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, apiFetch } from '../api';

const s = {
  page: { padding: '32px 20px', maxWidth: '420px', margin: '0 auto' },
  heading: { fontSize: '20px', fontWeight: '700', color: '#222', marginBottom: '4px' },
  sub: { fontSize: '13px', color: '#888', marginBottom: '28px' },
  label: { display: 'block', fontSize: '12px', fontWeight: '700', color: '#555', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  input: {
    width: '100%', padding: '12px 14px', border: '1.5px solid #e0e0e0',
    borderRadius: '8px', fontSize: '14px', marginBottom: '16px', outline: 'none',
    boxSizing: 'border-box', transition: 'border-color 0.2s',
  },
  btn: {
    width: '100%', padding: '13px', background: '#DB3267', color: '#fff',
    borderRadius: '8px', fontWeight: '700', fontSize: '15px',
    border: 'none', cursor: 'pointer', marginBottom: '10px',
  },
  btnGhost: {
    width: '100%', padding: '11px', background: 'none', color: '#888',
    borderRadius: '8px', fontWeight: '600', fontSize: '14px',
    border: '1.5px solid #e0e0e0', cursor: 'pointer',
  },
  error: {
    background: '#fce8ef', color: '#b8254f', borderRadius: '8px',
    padding: '10px 14px', fontSize: '13px', marginBottom: '16px',
  },
  success: {
    background: '#e8f5e9', color: '#2e7d32', borderRadius: '8px',
    padding: '10px 14px', fontSize: '13px', marginBottom: '16px',
  },
};

export default function ChangePassword({ user }) {
  const navigate = useNavigate();
  const [current, setCurrent]   = useState('');
  const [newPw, setNewPw]       = useState('');
  const [confirm, setConfirm]   = useState('');
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (newPw.length < 6) { setError('New password must be at least 6 characters.'); return; }
    if (newPw !== confirm) { setError('New passwords do not match.'); return; }
    setSaving(true);
    const res  = await apiFetch(`${API}/users/${user.id}`, {
      method:  'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ action: 'changePassword', currentPassword: current, newPassword: newPw }),
    });
    const data = await res.json();
    setSaving(false);
    if (!data.ok) { setError(data.error || 'Failed to change password.'); return; }
    setSuccess(true);
    setCurrent(''); setNewPw(''); setConfirm('');
  }

  return (
    <div style={s.page}>
      <h1 style={s.heading}>Change Password</h1>
      <p style={s.sub}>Choose a new password for your account</p>

      {error   && <div style={s.error}>{error}</div>}
      {success && <div style={s.success}>Password changed successfully!</div>}

      <form onSubmit={handleSubmit}>
        <label style={s.label}>Current Password</label>
        <input style={s.input} type="password" value={current} onChange={e => setCurrent(e.target.value)} placeholder="Enter current password" />

        <label style={s.label}>New Password</label>
        <input style={s.input} type="password" value={newPw} onChange={e => setNewPw(e.target.value)} placeholder="At least 6 characters" />

        <label style={s.label}>Confirm New Password</label>
        <input style={s.input} type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat new password" />

        <button style={{ ...s.btn, opacity: saving ? 0.6 : 1 }} type="submit" disabled={saving}>
          {saving ? 'Saving...' : 'Change Password'}
        </button>
      </form>

      <button style={s.btnGhost} onClick={() => navigate(-1)}>← Back</button>
    </div>
  );
}
